module.exports = function() {
  return new Worker(__webpack_public_path__ + "a27512d3091ecd8bac57.worker.js");
};